import createHistory from 'history/createBrowserHistory';
import { router as config } from '../config';

export default createHistory({ basename: config.basename });
